import { render, staticRenderFns } from "./selectAddress.vue?vue&type=template&id=2bd18903&scoped=true&"
import script from "./selectAddress.vue?vue&type=script&lang=js&"
export * from "./selectAddress.vue?vue&type=script&lang=js&"
import style0 from "./selectAddress.vue?vue&type=style&index=0&id=2bd18903&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd18903",
  null
  
)

export default component.exports